import React, { useContext, useEffect, useState } from "react";
import { Dropdown, Menu, Button, Tooltip } from "antd";
import { FiHelpCircle, FiLogOut, FiMenu } from "react-icons/fi";

import { confirm } from "../../services/notifications";
import classes from "./navbar.module.scss";
import icon from "./../../assets/images/user.png";
import jwtDecode from "jwt-decode";
import Sidebar from "./sidebar";
import { useSide } from "../../store/sidebar-context";
import pdf from "../../assets/pdf/Manual creación documentos Word dinámico.pdf"

const Navbar = (props) => {
  const [usuario, setUsuario] = useState();
  let { sideBarVisible, setSideBarVisible } = useSide();

  const open = () => {
    setSideBarVisible(!sideBarVisible);
  };
  useEffect(() => {
    const token = jwtDecode(localStorage.getItem("token"));
    setUsuario(token.nombre);
  }, []);

  const onClickLogout = async () => {
    const confirmed = await confirm(
      `Cerrar Sesión`,
      `¿Esta seguro que desea cerrar la sesión?`
    );

    if (!confirmed) {
      return;
    }

    localStorage.clear();
    // sessionStorage.clear();
    window.location.replace("/login");
  };
  const sidebarres = () => {
    return <Sidebar />;
  };

  const items = [
    {
      icon: <FiLogOut />,
      label: "Cerrar sesión",
      key: 2,
      onClick: onClickLogout,
    }
  ]

  const onClickPdf = (event) => {
    event.stopPropagation();
    window.open(pdf, "_blank");
  };


  return (
    <React.Fragment>
      <div className={classes.navbar}>
        {!sideBarVisible && (
          <Button
            type="text"
            shape="circle"
            size="large"
            onClick={() => {
              open();
            }}
          >
            <FiMenu />
          </Button>
        )}
        <span />
        <Dropdown menu={{ items }} placement="bottomRight" trigger="click" arrow>
          <div className={classes.user}>
            {/* Wrapping the PDF button in a container */}
            <div onClick={onClickPdf}>
              <Tooltip title="Ayuda">
                <Button
                  type="text"
                  shape="circle"
                  icon={<FiHelpCircle />}
                  size="large"
                />
              </Tooltip>
            </div>
            <div className={classes.data}>
              <div className={classes.name}>{usuario}</div>
            </div>
            <img className={classes.image} src={icon} alt="user" />
          </div>
        </Dropdown>
      </div>
    </React.Fragment>
  );
};

export default Navbar;
